<template>
    <div class="col-12">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-2">
                    <div class="card-body text-elev-blue">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="card-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                        </svg>
                    </div>
                </div>
                <div class="col-10">
                    <div class="card-body pb-0">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <h5 class="card-title text-xs">{{ orderLabel }} #{{ orderNumber }}</h5>
                                <p class="text-2xl mb-0"><strong>{{ amountToPay }}</strong></p>
                            </div>
                            <div class="col-12 col-sm-6">
                                <p class="text-lg mb-0"><strong>{{ $t('Detaljer') }}</strong></p>
                                <div v-if="isPartlyPaid">
                                    <p class="text-xs mb-1">{{ $t('Betalingsstatus')}}: {{ paymentStatus }}</p>
                                    <p class="text-xs mb-1">{{$t('Betalt')}}: {{ paidAmount }}</p>
                                    <p class="text-xs mb-1">{{$t('Totalt beløp')}}: {{ totalAmount }}</p>
                                </div>
                                <p class="text-xs mb-1">{{ $t('Dato')}}: {{ orderDate }}</p>
                                <p class="text-xs mb-1">{{ $t('Forfallsdato')}}: {{ dueDate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="hr-wrapper">
                        <hr>
                    </div>
                    <div class="card-body pt-1">
                        <div class="row">
                            <div class="col-12 col-sm-6 pe-sm-1" v-if="!isBillecta && paymentMethod">
                                <a class="btn btn-success btn-block py-2" :href=" '/payment?method=' + paymentMethod + '&aoh_id=' + id "><strong>{{ $t("Betal nå") }}</strong></a>
                            </div>
                            <div class="col-12 col-sm-6 mt-1 mt-sm-0 ps-sm-1">
                                <a class="btn btn-secondary btn-block py-2" :href="downloadLink" target="_blank">{{ $t("Last ned") }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps(['invoice', 'paymentMethod', 'isApp', 'hashedKey'])

const id = computed(() => props.invoice.id)
const amountToPay = computed(() => props.invoice.amount_due_formatted)
const paidAmount = computed(() => props.invoice.paid_amount_formatted)
const totalAmount = computed(() => props.invoice.amount_formatted)
const orderNumber = computed(() => props.invoice.order_number)
const orderLabel = computed(() => props.invoice.order_label)
const paymentStatus = computed(() => props.invoice.readable_payment_status)
const orderDate = computed(() => props.invoice.order_date)
const dueDate = computed(() => props.invoice.order_due_date)
const isBillecta = computed(() => props.invoice.is_billecta)
const isPartlyPaid = computed(() => props.invoice.partly_paid)
const downloadLink = computed(() => '/document/' + id.value + '?aoh=1' + (props.isApp ? '&auth=' + props.hashedKey : ''))
</script>